import styled from 'styled-components';

export const Content = styled.div`
  padding: 20px;
  box-sizing: border-box;
  }
`;

export const WrapMessage = styled.div`
  width: 100%;
  gap: 16px;
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #e6eaec;
  svg {
    flex: 0 0 auto;
  }
`;

export const Buttons = styled.div`
  justify-content: space-between;
  gap: 12px;
  display: flex;
  & button {
    flex-grow: 1;
    width: 50%;
  }
`;
